exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background:url(" + require("../../public/images/not-found-bg.jpg") + ") no-repeat 50% fixed;background-size:cover}.jumbotron-container{height:82vh}.jumbotron{background-color:hsla(0,0%,100%,.8);text-align:center}.jumbotron h1{font-size:52px;margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/css-loader!../graylog2-server/graylog2-web-interface/src/pages/NotFoundPage.css
// module id = 357
// module chunks = 0